export default "__VITE_ASSET__OFvpEdNa__"